import { useLocation, useNavigate } from 'react-router-dom'
import { Box, Grid, Typography, Button, Stack } from '@mui/material'
import { useAuth, useExecutionReportContext } from '../../context'

const NoPermissionPage = ({ error: propError, onClear: propOnClear, onLogout: propOnLogout, returnPath: propReturnPath }) => {
    const location = useLocation()
    const navigate = useNavigate()
    const { logout, refreshSessionToken } = useAuth()
    const { exportLocalReportData } = useExecutionReportContext() || {}

    const { error: stateError, returnPath: stateReturnPath } = location.state || {}

    const error = propError || stateError
    const returnPath = propReturnPath || stateReturnPath || '/welcome'

    const finalError = {
        title: error?.title || 'Acceso Denegado',
        message: error?.message || 'No tienes los permisos necesarios para acceder a este recurso.'
    }

    const onClear = () => {
        if (propOnClear) {
            propOnClear()
        } else {
            navigate(returnPath, { replace: true })
        }
    }

    const onLogout = () => {
        if (propOnLogout) {
            propOnLogout()
        } else {
            logout()
        }
    }

    const handleRefreshPermissions = async () => {
        const ok = await refreshSessionToken()
        if (ok) {
            alert('Permisos refrescados correctamente. Intentando volver.')
            onClear()
        } else {
            alert('No se pudo refrescar los permisos. Verifica tu conexión a internet.')
        }
    }

    const handleExportBackup = async () => {
        if (exportLocalReportData) {
            await exportLocalReportData()
        } else {
            alert('No hay reporte local disponible para exportar.')
        }
    }

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                pt: propError ? 0 : 12
            }}
        >
            <Box
                sx={{
                    p: 4,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: propError ? 0 : 24,
                    maxWidth: 550,
                    width: '100%',
                    textAlign: 'center'
                }}
            >
                <Grid container direction="column" spacing={2} alignItems='center'>
                    <Grid item>
                        <Typography variant="h4" component="h1" color="error" sx={{ fontWeight: 'bold' }}>
                            {finalError.title}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1" sx={{ textAlign: 'center' }}>
                            {finalError.message}
                        </Typography>
                        <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 1 }}>
                            puedes refrescar tus permisos en caso de refrescar cache local, volver o cerrar sesión para iniciar nuevamente.
                        </Typography>
                    </Grid>
                    <Grid item sx={{ width: '100%', pt: 2 }}>
                        <Stack direction="row" spacing={1} justifyContent="center" flexWrap="wrap" useFlexGap sx={{ gap: 1 }}>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={onClear}
                            >
                                Volver
                            </Button>
                            <Button
                                variant="contained"
                                color="info"
                                onClick={handleRefreshPermissions}
                            >
                                Refrescar Permisos
                            </Button>
                            {/* <Button
                                variant="outlined"
                                color="warning"
                                onClick={handleExportBackup}
                            >
                                Respaldo Local (JSON)
                            </Button> */}
                            <Button
                                variant="contained"
                                color="error"
                                onClick={onLogout}
                            >
                                Cerrar Sesión
                            </Button>
                        </Stack>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default NoPermissionPage
